import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "$styles/excel-formula.css"
import Prism from "prismjs"
import "prismjs/components/prism-excel-formula"

// Named LAMBDAs commonly contain periods, which Prism's stock Excel pattern omits.
Prism.languages["excel-formula"]["function-name"].pattern = /\b[A-Z][\w.]*(?=\()/i

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

Prism.highlightAll()
